<script lang="ts">
    import screenfull from 'screenfull';

    let component;

    const onToggle = () => {
        if (screenfull.isEnabled && component?.nextElementSibling) {
            screenfull.toggle(component.nextElementSibling);
        }
    };

    const onRequest = () => {
        if (screenfull.isEnabled && component?.nextElementSibling) {
            screenfull.request(component.nextElementSibling);
        }
    };

    const onExit = () => {
        if (screenfull.isEnabled && component?.nextElementSibling) {
            screenfull.exit();
        }
    };
</script>

<div style="width:0; height:0" bind:this={component} />
<svelte:window on:beforeunload={onExit} />
<slot {onToggle} {onRequest} {onExit} />
